/**
 * Current user class
 * Fed from the endpoint /users/me
 */
export default class {
  constructor (data) {
    const pictureProfileUrl = new URL(data.picture_profile_url)
    pictureProfileUrl.searchParams.set('size', '64x64')
    this.id = ~~data.id
    this.firstName = data.first_name
    this.lastName = data.last_name
    this.username = data.username
    this.extension = data.extension
    this.company = data.company
    this.dids = data.dids
    this.email = data.email
    this.realm = data.realm
    this.realmId = data.realm_id
    this.authLevel = data.auth_level
    this.parentRealm = data.parent_realm
    this.pictureProfileUrl = pictureProfileUrl.href
    this.rocketUsername = data.rocket_username
    this.emergencyCalleridCallbackProfileId = data.emergency_callerid_callback_profile_id
    this.emergencyCalleridDispatchableLocationId = data.emergency_callerid_dispatchable_location_id
  }
}
